<template>
  <!-- Header -->
  <div class="relative md:pt-24 pb-32 pt-12" style="background: rgb(0,5,116);
background: linear-gradient(126deg, rgba(0,5,116,1) 35%, rgba(95,135,176,1) 100%);">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
        
        </div>
      </div>
    </div>
  </div>
</template>

